import { useSidebarStore } from "@/stores/useSidebarStore";
import { useHubspotChat } from "@/hooks/useHubspotChatbot";
import { Button } from "@heroui/react";
import { cn } from "@/utils";
import { Trans } from "@lingui/react/macro";
import { MessagesSquare } from "lucide-react";
import { t } from "@lingui/core/macro";
import useAccountInfo from "@/hooks/useAccountInfo";
import { formatUnreadCount } from "./formatUnreadCount";

export const SupportChatToggle = () => {
  const sidebarOpen = useSidebarStore((state) => state.isOpen);
  const accountInfo = useAccountInfo((state) => state.accountInfo);

  const { activeConversation, unreadCount, isLoading, openHandler } =
    useHubspotChat({
      email: accountInfo?.userEmail,
      name: accountInfo?.userName,
      lastName: accountInfo?.userLastName,
      phone: accountInfo?.userPhone,
    });

  const hasUnread = unreadCount > 0;

  return (
    <Button
      className={cn(
        "w-full shrink-0 justify-start rounded-4xl px-3 text-gray-500",
        "transition-all duration-150",
        { "rounded-3xl": sidebarOpen },
        { "-ml-1": isLoading },
      )}
      variant="light"
      isIconOnly={!sidebarOpen}
      onPress={openHandler}
      size="sm"
      isLoading={isLoading}
      isDisabled={isLoading}
      aria-label={t`Odpri klepet s svetovalcem`}
    >
      <div className="flex w-full items-center gap-2">
        <div className="relative">
          <MessagesSquare size={16} className="-ml-0.5 shrink-0" />

          {hasUnread ? (
            <span
              className="bg-danger absolute -top-1 -right-1 size-2 animate-pulse rounded-full"
              aria-hidden
            />
          ) : activeConversation ? (
            <div className="absolute -top-1 -right-1 size-2 rounded-full bg-green-500" />
          ) : null}
        </div>

        {sidebarOpen ? (
          <div
            className={cn(
              "pointer-events-none text-xs font-medium text-gray-500 opacity-0 transition-all duration-200 ease-out",
              {
                "pointer-events-auto opacity-100": sidebarOpen,
              },
            )}
          >
            <Trans>Odpri klepet s svetovalcem</Trans>
          </div>
        ) : null}

        {sidebarOpen && hasUnread ? (
          <span className="bg-danger ml-auto flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-[10px] leading-none font-semibold text-white">
            {formatUnreadCount(unreadCount)}
          </span>
        ) : null}
      </div>
    </Button>
  );
};
